import axios from "axios";

const createApiInstance = (baseURL) => {
    const api = axios.create({ baseURL });

    api.interceptors.request.use(
        (config) => {
            const accessToken = localStorage.getItem("accessToken");
            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    api.interceptors.response.use(
        (response) => response,
        async (error) => {
            const originalRequest = error.config;

            if (error.response && error.response.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;

                try {
                    const oldRefreshToken = localStorage.getItem("refreshToken");
                    if (!oldRefreshToken) throw new Error("No refresh token available");

                    const response = await axios.post(
                        `${process.env.REACT_APP_API_URL}v1/adminRefresh/refresh`,
                        { refreshToken: oldRefreshToken },
                        { headers: { Authorization: `Bearer ${oldRefreshToken}` } }
                    );

                    const { accessToken, refreshToken } = response.data;
                    localStorage.setItem("accessToken", accessToken);
                    localStorage.setItem("refreshToken", refreshToken);

                    originalRequest.headers.Authorization = `Bearer ${accessToken}`;
                    return api(originalRequest);
                } catch (refreshError) {
                    localStorage.removeItem("accessToken");
                    localStorage.removeItem("refreshToken");
                    window.location.href = "/signin";
                    return Promise.reject(refreshError);
                }
            }

            return Promise.reject(error);
        }
    );

    return api;
};

export const apiV1 = createApiInstance(`${process.env.REACT_APP_API_URL}v1/`);
export const apiV2 = createApiInstance(`${process.env.REACT_APP_API_URL}v2/`);
